import React from 'react';

import PersonalisationSlotHeader from '../PersonalisationSlotHeader';
import { CheckboxInput } from '../CheckboxInput';
import { usePersonalisationContext } from '../../context/PersonalisationContext';

import { processTextWithLinks } from '../../utilities/processTextWithLinks';
import styles from './personalisation-checkbox-slot.module.css';

/**
 * PersonalisationCheckboxSlot component displays an informational slot in the personalisation journey.
 *
 * @param {Object} props - The component props
 * @param {Object} props.slot - The slot data
 * @returns {import('react').JSX.Element} The rendered component
 */
export default function PersonalisationCheckboxSlot({ slot }) {
  const { updateSelections, selections } = usePersonalisationContext();

  // Get current selection for this slot.
  const currentSelection = selections.slots.find((s) => s.id === slot.id);
  const isChecked = Boolean(currentSelection?.selected);

  const handleCheckboxChange = (checked) => {
    updateSelections({
      slotId: slot.id,
      itemSelected: checked
    });
  };

  return (
    <div>
      <PersonalisationSlotHeader slot={slot} processHeading={false} />
      {slot.checkboxHeading && (
        <p className={styles['personalisation__checkbox-heading'] + ' body-base'}>
          {processTextWithLinks(slot.checkboxHeading)}
        </p>
      )}
      <CheckboxInput
        id={slot.id}
        name={`checkbox-${slot.id}`}
        required={slot.isRequired}
        labelText={slot.checkboxLabel}
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
    </div>
  );
}
